import { usePage } from "@inertiajs/react";

import SeriesHeader from "components/series/SeriesHeader";
import SeriesTabBar from "components/series/SeriesTabBar";
import { Letterbooks } from "features/Letterbooks";
import DynamicListContainer from "features/tags/components/TagHeader/DynamicListContainer/DynamicListContainer";
import Callout from "hardcover-ui/components/Callout";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import classNames from "lib/classNames";

import { SeriesShowPageProps } from "./show.props";

function BrowseTagBooksPage() {
  const { series, letterbooks, view } = usePage<SeriesShowPageProps>().props;

  return (
    <div
      className="relative"
      style={{
        marginTop: "-64px",
        paddingTop: "64px",
      }}
    >
      <div className="absolute top-0 bg-repeat bg-top w-full md:h-[300px] h-[150px]">
        <div
          className={classNames(
            "bg-linear-to-b from-transparent to-white dark:to-gray-800 h-full flex flex-col justify-end items-center",
            "lg:from-50% lg:to-100%",
            "to-80%",
          )}
        />
      </div>
      <div className="relative lg:pt-8 mt-[0px] lg:mt-[0px]">
        <DynamicListContainer view={view}>
          <>
            <SeriesHeader series={series} />
            <SeriesTabBar series={series} />
            {letterbooks.letterbooks.length === 0 ? (
              <div className="p-4">
                <Callout>
                  <>There are no books in this series.</>
                </Callout>
              </div>
            ) : (
              <div className="pt-4 lg:p-4">
                <Letterbooks context={letterbooks} />
              </div>
            )}
          </>
        </DynamicListContainer>
      </div>
    </div>
  );
}

BrowseTagBooksPage.layout = DefaultLayoutWrapper;
export default BrowseTagBooksPage;
